<template>
  <div>
    <div class="d-flex justify-content-center justify-content-lg-end" v-if="disabled">
      <vb-button
        v-if="show_locked"
        :vb_options="{
          text: 'Scegli una camera per continuare',
          variant: 'info',
          size: 'lg',
          disabled: true,
          icon_disabled: 'lock',
        }"
      />
    </div>
    <div ref="cta_continue" class="d-flex justify-content-center justify-content-lg-end" v-else>
      <custom-link
        :route_name="'quote'"
        :wrap="'a'"
      >
        <template #content>
          <vb-button
            :vb_options="{
              text: 'Continua',
              variant: 'info',
              size: 'lg',
            }"
          />
        </template>
      </custom-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'room-select-button',
  props: {
    disabled: {
      type: Boolean,
      default: true,
    },
    show_locked: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    scroll_into_view() {
      if (this.$refs.cta_continue) {
        const rect = this.$refs.cta_continue.getBoundingClientRect()
        const target = window.pageYOffset + rect.bottom - window.innerHeight + 100
        window.scrollTo({ top: target, behavior: 'smooth' })
      }
    },
  },
}
</script>
